<template>
    <div>
        <v-card v-if="gateway" height="100%">
            <v-toolbar flat height="unset" class="py-2">
                <p class="line"></p>
                <v-toolbar-title class="pl-4">
                    <p class="subtitle-1 text-uppercase font-weight-bold ma-0 primary--text" style="white-space: normal;">
                        {{ gateway.name }}
                    </p>
                    <p class="caption ma-0">
                        {{ gateway.description }}
                    </p>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-chip-group
                    v-model="type_graph"
                    mandatory
                    active-class="active"
                    >
                    <v-chip value="bar" class="ml-3">
                        <v-icon small>mdi-poll</v-icon>
                    </v-chip>
                    <v-chip value="area" >
                        <v-icon small>mdi-chart-line-variant</v-icon>
                    </v-chip>
                </v-chip-group>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-0" style="height: 80%">
                <v-chip-group
                    mandatory
                    active-class="active"
                    >
                    <v-chip @click="changeType('day')">
                        Hoy
                    </v-chip>
                    <v-chip @click="changeType('week')">
                        Semana
                    </v-chip>
                    <v-chip class="px-6 ml-0 mr-6" @click="changeType('month')">
                        Mes
                    </v-chip>
                    <v-chip value="custom" @click="changeType('custom')">
                        Personalizar Rango
                    </v-chip>
                </v-chip-group>
                <div class="content">
                    <Chart 
                        v-if="type && data[type].loaded" 
                        :data="data[type]" 
                        :freq="freq" 
                        :type="type_graph"
                        :hideArrows="type === 'custom'"
                        @before="before"
                        @next="next"/>
                    <div 
                        v-else-if="type === 'custom' && datepickerObj.value == null"
                        class="ma-auto">
                            Selecciona un rango de fechas
                    </div>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="accent"
                        class="ma-auto"
                    ></v-progress-circular>
                </div>
            </v-card-text>
        </v-card>
        <datepicker 
            :open="datepickerObj.open" 
            @close="datepickerObj.open = false"
            @newValues="setCustomValues"/>
    </div>
</template>

<script>
import datepicker from './datePicker'
import { mapActions } from 'vuex'
import Chart from '../graphs/Chart'
export default {
    name: 'graphs',
    props: ['gateway', 'meters'],
    components: { Chart, datepicker },
    data() {
        return {
            type: null,
            type_graph: 'bar',
            freq: 'hour',
            datepickerObj:{
                open: false,
                value: null
            },
            data: {
                day:{
                    loaded: false,
                    series: [],
                    freq: 'hour'
                },
                week:{
                    loaded: false,
                    series: [],
                    freq: 'day'
                },
                month:{
                    loaded: false,
                    series: [],
                    freq: 'day'
                },
                custom:{
                    loaded: false,
                    series: [],
                    type: null,
                    times: null
                }
            }
        }
    },
    methods:{
        ...mapActions({
            getSummaryData: 'meters/getSummaryData'
        }),
        async getData(options){
            return this.getSummaryData({
                meters: this.meters,
                type: this.type,
                options
            })
        },
        async dayData(){
            let day = new Date()
            this.formatByHours(day.getHours(), day.getTime())
        },
        async weekData(){
            this.formatByDays(7, new Date().getTime())
        },
        async monthData(){
            this.formatByDays(30, new Date().getTime())
        },
        before(){
            const start = this.data[this.type].categories[0]
            
            if(this.type === 'day')
                this.formatByHours(24 , start.getTime())
            else if(this.type === 'week')
                this.formatByDays(7, start.getTime())
            else if(this.type === 'month')
                this.formatByDays(30, start.getTime())
        },
        next(){
            const lenCategory = this.data[this.type].categories.length
            const today = new Date()
            const start = this.data[this.type].categories[lenCategory - 1]
            start.setHours(0)
            start.setDate(start.getDate() + 1)
            
            if(this.type === 'day'){
                if(today.getFullYear() > today.getFullYear() || today.getMonth() > start.getMonth() || start.getDate() <= today.getDate())
                    this.formatByHours(24 , start.getTime() + (1000 * 60 * 60 * 24))
            }else if(this.type === 'week'){
                if(today.getFullYear() > today.getFullYear() || today.getMonth() > start.getMonth() || today.getDate() - 1 > start.getDate())
                    this.formatByDays(7 , start.getTime() + (1000 * 60 * 60 * 24 * 7))
            }else if(this.type === 'month'){
                if(today.getFullYear() > today.getFullYear() || today.getMonth() > start.getMonth() || today.getDate() - 1 > start.getDate())
                    this.formatByDays(30 , start.getTime() + (1000 * 60 * 60 * 24 * 30))
            }
            
        },
        async setCustomValues(event){
            this.freq = event.type
            const options = {
                times: { start: event.start, end: event.end },
                type: event.type
            }
            if(event.type === 'hour'){
                this.formatByHours(24 , event.end.getTime(), options)
            }else if(event.type === 'day'){
                this.freq = 'day'
                let n_days = parseInt((event.end.getTime() - event.start.getTime()) / (1000 * 60 * 60 * 24))
                this.formatByDays(n_days , event.end.getTime(), options)
            }
        },
        async formatByHours(n_hours, start, options){
            try {
                this.data[this.type].loaded = false
                
                const architecture = this.gateway.hasOwnProperty('architecture') ? this.gateway.architecture : true
                const start_req = new Date(start)
                start_req.setMinutes(0,0,0)
                
                let records = options
                    ? await this.getData(options)
                    : await this.getData({ start: start_req.getTime() - (n_hours * 1000 * 60 * 60) })

                const hour = 1000 * 60 * 60 
                let hours = Array.from({ length: n_hours }, (_, i) =>
                    new Date(start).getTime() - ((n_hours - i) * hour)
                )
                this.data[this.type].series = records.map( (reads, index) => {
                    const data = hours.map( h => {
                        const time = new Date(h)
                        const read = reads.find( read => 
                            read._id.hour == time.getHours()
                            && read._id.day == time.getDate() 
                            && read._id.month == time.getMonth() + 1
                        )
                        if(read)
                            return parseFloat(read.lines[0].kwht.toFixed(2)) 
                        else
                            return null
                    })
                    return {
                        name: this.meters[index].type == 'consumption' 
                            ? architecture
                                ? 'Neto'
                                : 'Consumo'
                            : 'Generación',
                        data
                    }
                } )
                
                const sum = { 
                    name: architecture ? 'Consumo' : 'Neto', 
                    data: new Array(n_hours).fill(0) 
                }
                this.data[this.type].series.forEach( serie => {
                    const operation = architecture 
                        ? 1 
                        : serie.name === 'Generación' ? -1: 1

                    serie.data.forEach( (value, i) => 
                        sum.data[i] = parseFloat((parseFloat(sum.data[i]) + (value * operation)).toFixed(2))
                    )
                })
                if(architecture) sum.data = this.removeNegatives(sum.data)
                this.data[this.type].series.push(sum)
                
                this.data[this.type].categories = hours.map( h => new Date(h) )
                this.data[this.type].loaded = true
            } catch (error) {
                console.log(error)
            }
        },
        async formatByDays(n_days, start, options){
            try {
                this.data[this.type].loaded = false
                const arquitecture = this.gateway.hasOwnProperty('architecture') ? this.gateway.architecture : true
                const day = 1000 * 60 * 60 * 24
                const start_req = start - (day * n_days)
                
                let records = options
                    ? await this.getData(options)
                    : await this.getData({ start: new Date(start_req).getTime(), end: new Date(start).getTime() })
                
                let days = Array.from({ length: n_days }, (_, i) =>
                    new Date(start).getTime() - ((n_days - i) * day)
                )
                this.data[this.type].series = records.map( (reads, index) => {
                    const data = days.map( d => {
                        const day = new Date(d)
                        const read = reads.find( read => 
                            read._id.day == day.getDate() 
                            && read._id.month == day.getMonth() + 1
                        )
                        if(read)
                            return parseFloat(read.lines[0].kwht.toFixed(2)) 
                        else
                            return null
                    })
                    return {
                        name: this.meters[index].type == 'consumption' 
                            ? arquitecture
                                ? 'Neto'
                                : 'Consumo'
                            : 'Generación',
                        data
                    }
                } )
                
                const sum = { 
                    name: arquitecture ? 'Consumo' : 'Neto', 
                    data: new Array(n_days).fill(0) 
                }
                this.data[this.type].series.forEach( serie => {
                    const operation = arquitecture 
                        ? 1 
                        : serie.name === 'Generación' ? -1: 1

                    serie.data.forEach( (value, i) => 
                        sum.data[i] = parseFloat((sum.data[i] + (parseFloat(value) * operation) ).toFixed(2)) 
                    )
                })
                if(arquitecture) sum.data = this.removeNegatives(sum.data)
                this.data[this.type].series.push(sum)

                this.data[this.type].categories = days.map( d => new Date(d) )
                this.data[this.type].loaded = true
            } catch (error) {
                console.log(error)
            }
        },
        removeNegatives(values){
            return values.map( v => v < 0 ? 0 : v )
        },
        changeType(type){
            this.type = type
            this.freq = this.data[this.type].freq
            if(this.type === 'custom') return this.datepickerObj.open = true
            this[`${this.type}Data`]()
        },
        reset(){
            this.data.day.loaded = false
            this.data.week.loaded = false
            this.data.month.loaded = false
            this.data.custom.loaded = false
        }
    },
    watch:{
        gateway(){
            this.reset()
            if(this.type === 'custom') return
            if(this.type) this[`${this.type}Data`]()
        }
    },
    mounted(){
        this.changeType('day')
    }
}
</script>

<style scoped>
    .active{
        color: var(--v-accent-base) !important;
        background-color: white !important;
        box-shadow: 0 0 16px -9px black;
    }
    .v-chip{
        border-radius: 15px;
        font-size: 12px;
        height: 30px;
    }
    .v-chip:before {
        background-color: unset;
    }
    .content{
        height: 85%;
        width: 100%;
        display: flex;
    }
    .line{
        border-left: 2px solid var(--v-primary-base);
        height: 13px;
    }
</style>